import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { GlobalApi } from '../../../util/Global';
import { AppConfig } from '../../../config/AppConfig';

const useHttpGetGoogleIntegrationAuthOnMount = (redirect: boolean = true) => {
    const userApi: UserApi = useContainer(UserApi);
    const globalApi = useContainer(GlobalApi);
    const [isReady, setIsReady] = useState(false);
    const [hasToken, setHasToken] = useState(false);

    const { exec, abort } = userApi.googleIntegrationAuth({
        onSuccess: _ => setHasToken(true),
        onError: _ => {
            if (redirect) return globalApi.href(AppConfig.googleAuthURL);
            setHasToken(false);
        },
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { isReady, hasToken };
};

export default useHttpGetGoogleIntegrationAuthOnMount;
